<template>
  <side-base>
    <div class="swrap">
      <div class="smain">
        <van-cell
          title="测评老师"
          is-link
          :value-class="['van-ellipsis', teacherText ? 'selected':'']"
          :value="teacherText||'请选择'"
          @click="chooseCepingTeacher"
        />
        <van-cell
          title="测评模板"
          is-link
          :value-class="['van-ellipsis', templateText ? 'selected':'']"
          :value="templateText||'请选择'"
          @click="chooseCepingTemplate"
        />
        <div class="three-a-row">
          <div class="nav-title">测评日期</div>
          <div class="date-box">
            <input-date-range 
              :start="params.startDate" 
              :end="params.endDate" 
              @change="chooseCalendar"></input-date-range>
          </div>
        </div>
        <div class="three-a-row" >
          <div class="nav-title"><div>测评报告发布状态<van-popover
              v-model="showPopover2"
              trigger="click"
              theme="dark"
              placement="bottom-start"
              :offset="[-8, 6]"
            >
            录入中：报告内容仅录入了部分数据；<br/>
            待发布：报告内全部数据已录入，可直接发布；
              <template #reference>
                <van-icon name="question-o" size="var(--fs-md)" />
              </template>
            </van-popover></div>
          </div>
          <div class="nav-div">
            <div class="nav-box" v-for="item of cepingStaList" :key="item.id">
              <div
                class="item-nav"
                :class="{
                  active: params.statusList && params.statusList.includes(item.val),
                  all: (!params.statusList || !params.statusList.length) && item.val === '',
                }"
                @click="triggerSta(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <side-foot cancelText="重置" @cancel="reset" @confirm="confirm(getRet())" />
    </div>
  </side-base>
</template>

<script>
import sideMixinBase from '@x3/js/side/0_mixin/mixin-base.js';
import InputDateRange from '@x3/vue/comp/input-date-range.vue';

let defaultParams = {
  // 发布状态
  statusList: [],
  // 测评老师id集合
  teacherIds: [],
  teacherList: [],
  templateIds: [],
  templateList: [],
  startDate: '',
  endDate: '',
};

export default {
  name: 'ceping-filtrate',
  components: {},
  mixins: [sideMixinBase],
  data() {
    return {
      showPopover2: false,
      listAll: [],
      params: app.tool.clone(defaultParams),
      cepingStaList: [{
        name: '录入中',
        val: 1,
        id: 1
      },{
        name: '待发布',
        val: 2,
        id: 2
      },{
        name: '已发布',
        val: 3,
        id: 3
      }],
    }
  },
  computed: {
    teacherText (){
      let list = this.params.teacherList,
        text = '';
      if (list.length == 1) {
        text = list[0].name;
      } else if (list.length > 1) {
        text = `${list.length}个老师`;
      }
      return text;
    },
    templateText (){
      let list = this.params.templateList,
        text = '';
      if (list.length == 1) {
        text = list[0].name;
      } else if (list.length > 1) {
        text = `${list.length}个模板`;
      }
      return text;
    },
  },
  methods: {
    init() {
      let opts = this.$route.meta.options || {};
      if (opts.params) {
        let params = JSON.parse(JSON.stringify(opts.params));
        this.params = Object.assign(this.params, params);
      }
    },
    // 选择测评老师
    async chooseCepingTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.teacherIds,
        list: this.params.teacherList,
      });
      this.params.teacherIds = res.ids;
      this.params.teacherList = res.list;
    },
    // 选择测评模板
    async chooseCepingTemplate() {
      let res = await app.x3.side.xsCepingTplFiltrate({
        ids: this.params.templateIds,
        list: this.params.templateList,
      });
      this.params.templateIds = res.ids;
      this.params.templateList = res.list;
    },
    // 发布状态处理
    triggerSta(item) {
      let i = this.params.statusList.indexOf(item.val);
      if (i === -1) {
        this.params.statusList.push(item.val);
      } else {
        this.params.statusList.splice(i, 1);
      }
    },
    // 选择时间
    chooseCalendar(ret) {
      console.log(ret)
      this.params.startDate = ret.startDate
      this.params.endDate = ret.endDate
    },
    // 重置
    reset() {      
      let opts = this.$route.meta.options || {};
      if (opts.defaultParams) {        
        this.params = Object.assign({...defaultParams},  JSON.parse(JSON.stringify(opts.defaultParams)));
      } else {
        this.params = JSON.parse(JSON.stringify(defaultParams));
      }
    },
    async getRet() {
      return JSON.parse(
        JSON.stringify({
          params: this.params,
        })
      );
    },
  },
  created() {
    this.init();
  },
  components: {
    InputDateRange
  }
}
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .smain {
    flex: 1;
    overflow: auto;
    background-color: var(--white);
    .nav-div {
      display: flex;
      flex-wrap: wrap;
      margin: calc(var(--gap) * 8) calc(var(--gap) * 8) 0 0;
      
      // .nav-box {
      //   width: 33.33%;
      //   padding: calc(var(--gap) * 8);
      //   .item-nav {
      //     height: calc(var(--w) * 32);
      //     line-height: calc(var(--w) * 32);
      //     text-align: center;
      //     border-radius: var(--radius-md);
      //     background-color: var(--g1);
      //     white-space: nowrap;
      //     &.active,
      //     &.all {
      //       color: var(--c1);
      //       background-color: rgba(var(--c1-rgb), 0.08);
      //     }
      //   }
      // }
    }
  }
}
</style>